import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDots9Mui = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("circle", {
			cx: 2,
			cy: 2,
			r: 2,
			fill: "#90A4AE"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 8,
			cy: 2,
			r: 2,
			fill: "#90A4AE"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 14,
			cy: 2,
			r: 2,
			fill: "#90A4AE"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 2,
			cy: 8,
			r: 2,
			fill: "#90A4AE"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 8,
			cy: 8,
			r: 2,
			fill: "#90A4AE"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 14,
			cy: 8,
			r: 2,
			fill: "#90A4AE"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 2,
			cy: 14,
			r: 2,
			fill: "#90A4AE"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 8,
			cy: 14,
			r: 2,
			fill: "#90A4AE"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 14,
			cy: 14,
			r: 2,
			fill: "#90A4AE"
		})
	]
});
const ForwardRef = forwardRef(SvgDots9Mui);
export { ForwardRef as ReactComponent };
